import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../AbstractElements";
import { ClickIt } from "../../../Constants/Constants";
import { PositionAlertType } from "../../../Types/BonusUiType";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const PositionAlert:React.FC<PositionAlertType> = ({ position, color, title, span }) => {
  const handleAlert = () => {
    const Toast = Swal.mixin({
      toast: true,
      position: position,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: "success",
      title: "Signed in successfully",
    });
  };

  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card className="height-equal">
        <CommonCardHeader title={title} span={span} />
        <CardBody className="btn-showcase">
          <Btn color={color} className="m-0" onClick={handleAlert}>
            {ClickIt}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PositionAlert;
